 { 
    document.addEventListener('DOMContentLoaded', function() {
        const WEATHER_ICONS = {
            Rain: 'CloudRain',
            Snow: 'CloudSnow',
            Clouds: 'Cloud',
            Mist: 'CloudFog',
            Clear: 'Sun',
            Thunderstorm: 'CloudLightning'
        };
    
        function updateWeather() {
            fetch(weatherParams.ajaxurl + '?action=get_weather_data&nonce=' + weatherParams.nonce)
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        const weatherData = data.data;
                        updateTemperature(weatherData.main.temp);
                        updateWeatherDescription(weatherData.weather[0].description);
                        updateWeatherIcon(weatherData.weather[0].main);
                    } else {
                        console.error('Error fetching weather data:', data.data);
                    }
                })
                .catch(error => console.error('Error updating weather:', error));
        }
    
        function updateTemperature(temp) {
            const tempElement = document.getElementById('g6-weather-temperature');
            if (tempElement) {
                tempElement.textContent = `${Math.round(temp)}°`;
            }
        }
    
        function updateWeatherDescription(description) {
            const descElement = document.getElementById('g6-weather-description');
            if (descElement) {
                descElement.textContent = description;
            }
        }
    
        function updateWeatherIcon(weatherMain) {
            const iconElement = document.getElementById('g6-weather-icon');
            if (iconElement) {
                let iconName = WEATHER_ICONS[weatherMain] || 'Cloud';
                iconElement.src = `/wp-content/uploads/2024/08/${iconName}.svg`;
            }
        }
    
        // Update data every 10 minutes
        setInterval(updateWeather, 600000);
    
        // Optional: Refresh immediately after page loads
        //updateWeather();
    });
             
}